import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import type { CareersListFilterData } from '../types';

export interface CareersListFiltersProps {
  readonly onFilterChange: (value: string) => void;
  readonly selectedFilter: string;
}

const filters: CareersListFilterData[] = [
  {
    id: 0,
    value: '',
    text: 'careers_filter_view_all',
  },
  {
    id: 1,
    text: 'careers_filter_north_america',
    value: 'US',
  },
  {
    id: 2,
    text: 'careers_filter_europe',
    value: 'FI',
  },
];

interface CareersListFilterProps extends CareersListFilterData {
  readonly onChange: (department: string) => void;
  readonly selectedFilter: string;
}

const CareersListFilter = ({
  id,
  onChange,
  selectedFilter,
  text,
  value,
}: CareersListFilterProps) => {
  const t = useTranslations();
  const isSelected = selectedFilter === value;

  const handleChange = () => {
    onChange(value);
  };

  return (
    <div
      className="flex flex-row-reverse items-center gap-x-4"
      key={`region-${id}`}
    >
      <label
        className={cx('max-md:py-4', {
          'text-blue-200': isSelected,
          'text-sandstone-500': !isSelected,
        })}
        data-cy={`filter-label-${id}`}
        htmlFor={`filter-${id}`}
      >
        {t(text)}
      </label>
      <input
        checked={isSelected}
        className={cx(
          'max-md:sr-only md:block',
          'size-5 cursor-pointer appearance-none rounded-full transition-all',
          'border-2 border-solid border-sandstone-500',
          'checked:bg-blue-200',
        )}
        data-cy={`filter-radio-${id}`}
        id={`filter-${id}`}
        name="radio"
        onChange={handleChange}
        type="radio"
        value={value}
      />
    </div>
  );
};

const CareersListFilters = ({
  onFilterChange,
  selectedFilter,
}: CareersListFiltersProps) => {
  return (
    <div className="flex gap-x-4 md:mb-4 md:justify-end md:gap-x-12">
      {filters.map((filter) => (
        <CareersListFilter
          {...filter}
          key={filter.id}
          onChange={onFilterChange}
          selectedFilter={selectedFilter}
        />
      ))}
    </div>
  );
};

export default CareersListFilters;
